<script>
import { format, parseISO } from 'date-fns/fp'
import capitalize from 'lodash/capitalize'
import { TABLE_FIELDS } from '@kynd-points/constant'

export default {
  name: 'ActivityTableItem',
  props: {
    activityItem: { type: Object, required: true },
  },
  data() {
    return {
      tableFields: TABLE_FIELDS,
    }
  },
  computed: {
    formatDate() {
      return format('M/d/yyyy', parseISO(this.activityItem.post_date))
    },
    activity() {
      if (this.activityItem.ref_class === 'App\\StatusUpdate') {
        if (this.activityItem.memo.type === 'volunteered') {
          return this.activityItem.memo.hours + ' Volunteer Hours'
        }
        if (this.activityItem.memo.type === 'kyndness') {
          return 'I did an act of kyndness'
        }
        if (this.activityItem.memo.type === 'gratitude') {
          return 'I shared my gratitude'
        }
        if (this.activityItem.memo.type === 'donation') {
          return 'I donated'
        }
      }
      if (this.activityItem.ref_class === 'App\\User') {
        if (this.activityItem.tags[0] === 'sent') {
          return 'Sent a Gift'
        }
        if (this.activityItem.tags[0] === 'refused') {
          return 'Gift refused'
        }
        if (this.activityItem.tags[0] === 'accepted') {
          return 'Received a Gift'
        }
      }

      if (this.activityItem.ref_class === 'App\\Order') {
        if (this.activityItem.tags[0] === 'purchase') {
          return (
            'Points redeemed for ' +
            this.activityItem.memo.quantity +
            ' ' +
            this.activityItem.memo.product_title
          )
        }
        if (this.activityItem.tags[0] === 'refund') {
          return 'Order Cancelled – Points Refunded'
        }
      }
      return ''
    },
    status() {
      return capitalize(this.activityItem.tags[0])
    },
  },
}
</script>

<template>
  <div class="table-row h-10 even:bg-gray-lighter">
    <div :class="tableFields[0].class">
      {{ formatDate }}
    </div>
    <div :class="tableFields[1].class">
      {{ activity }}
    </div>
    <div :class="tableFields[2].class">
      {{ status }}
    </div>
    <div
      :class="[
        tableFields[3].class,
        'text-xl',
        +activityItem.beautiful_value > 0 ? 'text-blue' : 'text-aok_green',
      ]"
    >
      {{ activityItem.beautiful_value }}
    </div>
  </div>
</template>
